import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore.js";

export function StoreSelect() {
  const staff = useAuthStore((state) => state.staff);
  const accessibleStores = useAuthStore((state) => state.accessibleStores);
  const switchStore = useAuthStore((state) => state.switchStore);
  const error = useAuthStore((state) => state.error);
  const navigate = useNavigate();
  const [switching, setSwitching] = useState<string | null>(null);

  if (!staff) {
    return <Navigate to="/login" replace />;
  }

  const handleSelect = async (storeId: string) => {
    setSwitching(storeId);
    const ok = await switchStore(storeId);
    setSwitching(null);
    if (ok) {
      navigate("/", { replace: true });
    }
  };

  return (
    <div className="app-shell" style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
      <div className="card stack" style={{ width: 420 }}>
        <h1 style={{ textAlign: "center", fontSize: 22 }}>店舗を選択してください</h1>
        <p style={{ textAlign: "center", color: "var(--color-text-muted)" }}>
          {staff.name} さんがアクセスできる店舗一覧です
        </p>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="stack">
          {accessibleStores.map((store) => (
            <button
              key={store.id}
              className="btn btn-primary btn-lg btn-block"
              disabled={switching !== null}
              onClick={() => void handleSelect(store.id)}
            >
              {switching === store.id ? "切り替え中..." : store.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
